module.exports = __webpack_public_path__ + "img/Fedora.9c47316.svg";